import { useState } from "react";
import { useAtomValue } from "jotai";
import {
  activeSelectionAtom,
  activeVendorAtom,
  findRink,
  getRinks,
  setSelectedRink,
} from "./vendor";
import { Dropdown } from "./components";

export function RinkBadge() {
  const [expanded, setExpanded] = useState(false);
  const selection = useAtomValue(activeSelectionAtom);
  const activeVendor = useAtomValue(activeVendorAtom);

  if (!selection || !activeVendor) return null;

  const rinks = getRinks(activeVendor);
  const currentRink = findRink(selection.rinkId) ?? rinks[0];
  const interactive = rinks.length > 1;

  const label = (
    <span className="text-lg text-text-secondary flex items-center gap-2">
      <span>{currentRink.name}</span>
      {interactive && <span className="text-sm opacity-70">▾</span>}
    </span>
  );

  if (!interactive) return label;

  return (
    <Dropdown
      trigger={
        <button type="button" className="cursor-pointer">
          {label}
        </button>
      }
      open={expanded}
      onOpenChange={setExpanded}
      align="left"
      className="p-2 whitespace-nowrap text-left bg-bg-brand-alt text-text-on-brand-alt min-w-[12rem]"
    >
      {rinks.map((r) => (
        <div key={r.id}>
          <button
            type="button"
            onClick={() => {
              setSelectedRink(r.id);
              setExpanded(false);
            }}
            className={
              "w-full text-left px-2 py-1 rounded cursor-pointer hover:bg-black/10 " +
              (r.id === currentRink.id ? "font-medium" : "")
            }
          >
            {r.name}
          </button>
        </div>
      ))}
    </Dropdown>
  );
}

